import { STATUS_MAP } from "./constant";
import { isProd } from "@/services/_apiConfig/apiConfig";

export const firstCharacterOfWord = (str = "") => {
  const words = str.trim().split(/\s+/);
  if (words.length === 0) return "";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (
    words[0].charAt(0).toUpperCase() +
    words[words.length - 1].charAt(0).toUpperCase()
  );
};

export const compareFiles = (file1, file2) => {
  if (!file1 || !file2) {
    return false;
  }

  return (
    file1.name === file2.name &&
    file1.size === file2.size &&
    file1.type === file2.type &&
    file1.lastModified === file2.lastModified
  );
};

export const getStatusClass = (status, stepComplete) => {
  if (stepComplete) return "success";

  switch (status) {
    case STATUS_MAP.submitted_for_review.value:
    case STATUS_MAP.under_review.value:
    case STATUS_MAP.pending.value:
      return "info";

    case STATUS_MAP.input_required.value:
    case STATUS_MAP.awaiting_confirmation.value:
    case STATUS_MAP.partial.value:
    case STATUS_MAP.initiated.value:
      return "warning";

    case STATUS_MAP.rejected.value:
    case STATUS_MAP.incomplete.value:
    case STATUS_MAP.failed.value:
      return "error";

    case STATUS_MAP.completed.value:
    case STATUS_MAP.connected.value:
    case STATUS_MAP.verified.value:
    case STATUS_MAP.signed.value:
    case STATUS_MAP.approved.value:
      return "success";

    default:
      return "";
  }
};

export const formatAmount = (amount, currency) => {
  if (typeof amount !== "number") {
    return amount;
  }

  const formatter = new Intl.NumberFormat("en-AE", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  });

  return formatter.format(amount);
};

export const ALLOWED_COUNTRY_CODES = isProd ? ["ae"] : ["ae", "in"];

export const COUNTRY_CODE_MAP = {
  "+91": "in",
  "+971": "ae",
}
